"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BannerSectionAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/doctor-thumb-22.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-23.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-24.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-25.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
};

type BannerSectionH1sItem = {
    key: Key | null | undefined;
};
export type HomeNineBannerSectionGeneratedProps = {
    divDiv0Div0Div0ClassName?: string;
    /** Default: "#" */
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkHref?: string;
    /** Default: "+1 24565 89856" */
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkText?: ReactNode;
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkVisible?: boolean;
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Call Us" */
    divDiv0Div0Div0Div0Div0Div0Div0Div1Span0SpanText?: ReactNode;
    /** Default: "#" */
    divDiv0Div0Div0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "View All Services" */
    divDiv0Div0Div0Div0Div0Div0Link0LinkText?: ReactNode;
    divDiv0Div0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    divDiv0Div0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Compassionate" */
    divDiv0Div0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Homecare, Right" */
    divDiv0Div0Div0Div0Div0H10H1Text2?: ReactNode;
    divDiv0Div0Div0Div0Div0H10H1Visible?: boolean;
    divDiv0Div0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "at Your Doorstep" */
    divDiv0Div0Div0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "Certified nurses, physiotherapists, and attendants delivering hospital-grade care at home—convenience without compromise." */
    divDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "More then 25K clients" */
    divDiv0Div0Div0Div0Div1Div1P0PText?: ReactNode;
    /** Default: "reviews" */
    divDiv0Div0Div0Div0Div1Div1P0Span0SpanText?: ReactNode;
    /** Default: "banner-img" */
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-img-2.png" */
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "+" */
    divDiv0Div0Div0Div1Div0Div1P0PText?: ReactNode;
    /** Default: 10 */
    divDiv0Div0Div0Div1Div0Div1P0Span0SpanText?: ReactNode;
    /** Default: "Years of Experience" */
    divDiv0Div0Div0Div1Div0Div1P1PText?: ReactNode;
    /** Default: "+" */
    divDiv0Div0Div0Div1Div0Div2P0PText?: ReactNode;
    /** Default: 250 */
    divDiv0Div0Div0Div1Div0Div2P0Span0SpanText?: ReactNode;
    /** Default: "Certified Doctors" */
    divDiv0Div0Div0Div1Div0Div2P1PText?: ReactNode;
    /** Default: "+" */
    divDiv0Div0Div0Div1Div0Div3P0PText?: ReactNode;
    /** Default: 100 */
    divDiv0Div0Div0Div1Div0Div3P0Span0SpanText?: ReactNode;
    /** Default: "Satisfaction Rate" */
    divDiv0Div0Div0Div1Div0Div3P1PText?: ReactNode;
    /** Default: "shadow-img" */
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-two.png" */
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow-img" */
    divDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-nine-shadow.png" */
    divDiv0ImageWithBasePath0ImageSrc?: string;
    divDiv0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Home Care" */
    divDiv1DivText?: ReactNode;
    /** Default: "Home Care" */
    divDiv2DivText?: ReactNode;
    /** Default: "Home Care" */
    divDiv3DivText?: ReactNode;
    /** Default: "shadow-img" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-wave.png" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionAvatarAvatarRoundeds: BannerSectionAvatarAvatarRoundedsItem[];
    bannerSectionH1s: BannerSectionH1sItem[];
    bannerSectionAvatarAvatarRoundedsItemWrapper?: (item: BannerSectionAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsImageVisible?: boolean;
    bannerSectionAvatarAvatarRoundedsImageRenderer?: (item: BannerSectionAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionH1sItemWrapper?: (item: BannerSectionH1sItem, content: ReactNode) => ReactNode;
    bannerSectionH1sRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeNineBannerSectionGenerated: FC<HomeNineBannerSectionGeneratedProps> = ({
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkHref = "#",
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkText = "+1 24565 89856",
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkVisible,
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkRenderer,
    divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkProps,
    divDiv0Div0Div0Div0Div0Div0Div0Div1Span0SpanText = "Call Us",
    divDiv0Div0Div0Div0Div0Div0Link0LinkHref = "#",
    divDiv0Div0Div0Div0Div0Div0Link0LinkText = "View All Services",
    divDiv0Div0Div0Div0Div0Div0Link0LinkVisible,
    divDiv0Div0Div0Div0Div0Div0Link0LinkRenderer,
    divDiv0Div0Div0Div0Div0Div0Link0LinkProps,
    divDiv0Div0Div0Div0Div0H10H1Text = "Compassionate",
    divDiv0Div0Div0Div0Div0H10H1Text2 = "Homecare, Right",
    divDiv0Div0Div0Div0Div0H10H1Visible,
    divDiv0Div0Div0Div0Div0H10H1Renderer,
    divDiv0Div0Div0Div0Div0H10H1Props,
    divDiv0Div0Div0Div0Div0H10Span0SpanText = "at Your Doorstep",
    divDiv0Div0Div0Div0Div0P0PText = "Certified nurses, physiotherapists, and attendants delivering hospital-grade care at home—convenience without compromise.",
    divDiv0Div0Div0Div0Div1Div1P0PText = "More then 25K clients",
    divDiv0Div0Div0Div0Div1Div1P0Span0SpanText = "reviews",
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageAlt = "banner-img",
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-img-2.png",
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0Div1Div0Div1P0PText = "+",
    divDiv0Div0Div0Div1Div0Div1P0Span0SpanText = 10,
    divDiv0Div0Div0Div1Div0Div1P1PText = "Years of Experience",
    divDiv0Div0Div0Div1Div0Div2P0PText = "+",
    divDiv0Div0Div0Div1Div0Div2P0Span0SpanText = 250,
    divDiv0Div0Div0Div1Div0Div2P1PText = "Certified Doctors",
    divDiv0Div0Div0Div1Div0Div3P0PText = "+",
    divDiv0Div0Div0Div1Div0Div3P0Span0SpanText = 100,
    divDiv0Div0Div0Div1Div0Div3P1PText = "Satisfaction Rate",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt = "shadow-img",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-img-two.png",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps,
    divDiv0ImageWithBasePath0ImageAlt = "shadow-img",
    divDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-nine-shadow.png",
    divDiv0ImageWithBasePath0ImageVisible,
    divDiv0ImageWithBasePath0ImageRenderer,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv1DivText = "Home Care",
    divDiv2DivText = "Home Care",
    divDiv3DivText = "Home Care",
    divImageWithBasePath0ImageAlt = "shadow-img",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-wave.png",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
    spanImageWithBasePath0ImageProps,
    divDiv0Div0Div0ClassName,
    bannerSectionAvatarAvatarRoundeds,
    bannerSectionH1s,
    bannerSectionAvatarAvatarRoundedsItemWrapper,
    bannerSectionAvatarAvatarRoundedsRenderer,
    bannerSectionAvatarAvatarRoundedsImageVisible,
    bannerSectionAvatarAvatarRoundedsImageRenderer,
    bannerSectionAvatarAvatarRoundedsImageProps,
    bannerSectionH1sItemWrapper,
    bannerSectionH1sRenderer,
}) => {
    return (
        <div className="hero-section-nine">
            <div data-template-tag="HeaderSection" />
            <div className="banner-section-nine">
                <div className="container">
                    <div className={divDiv0Div0Div0ClassName ?? "row"}>
                        <div className="col-xl-5 col-lg-6">
                            <div className="section-header section-header-nine">
                                {renderNode(divDiv0Div0Div0Div0Div0H10H1Visible, divDiv0Div0Div0Div0Div0H10H1Renderer, (
                                    <h1 className="section-title mb-0 mb-2" {...(divDiv0Div0Div0Div0Div0H10H1Props ?? {})}>
                                        {divDiv0Div0Div0Div0Div0H10H1Text}
                                        {renderCollectionNode(
                                            bannerSectionH1s,
                                            (item: BannerSectionH1sItem) => (
                                                <br key={item.key} />
                                            ),
                                            bannerSectionH1sItemWrapper,
                                            bannerSectionH1sRenderer
                                        )}
                                        {divDiv0Div0Div0Div0Div0H10H1Text2}
                                        <br />
                                        <span className="text-gradient">{divDiv0Div0Div0Div0Div0H10Span0SpanText}</span>
                                    </h1>
                                ))}
                                <p className="paragraph">{divDiv0Div0Div0Div0Div0P0PText}</p>
                                <div className="banner-btn-nine d-flex align-items-center gap-4 flex-wrap">
                                    {renderNode(divDiv0Div0Div0Div0Div0Div0Link0LinkVisible, divDiv0Div0Div0Div0Div0Div0Link0LinkRenderer, (
                                        <SmartLink href={divDiv0Div0Div0Div0Div0Div0Link0LinkHref} className="btn btn-primary-gradient theme-9-btn" {...(divDiv0Div0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                            <i className="isax isax-category5" />
                                            {divDiv0Div0Div0Div0Div0Div0Link0LinkText}
                                        </SmartLink>
                                    ))}
                                    <div className="call-item">
                                        <div className="call-info-icon avatar avatar-lg rounded-circle">
                                            <i className="isax isax-call" />
                                        </div>
                                        <div className="call-info-text">
                                            <span className="link d-block">{divDiv0Div0Div0Div0Div0Div0Div0Div1Span0SpanText}</span>
                                            {renderNode(divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkVisible, divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkRenderer, (
                                                <SmartLink href={divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkHref} className="number" {...(divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkProps ?? {})}>{divDiv0Div0Div0Div0Div0Div0Div0Div1Link0LinkText}</SmartLink>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="rating-appointment flex-wrap">
                                <div className="avatar-list-stacked avatar-group-lg">
                                    {renderCollectionNode(
                                        bannerSectionAvatarAvatarRoundeds,
                                        (item: BannerSectionAvatarAvatarRoundedsItem) => (
                                            <span className={item.className ?? "avatar avatar-rounded"} key={item.key}>
                                                {renderItemNode(bannerSectionAvatarAvatarRoundedsImageVisible, bannerSectionAvatarAvatarRoundedsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof bannerSectionAvatarAvatarRoundedsImageProps === "function" ? bannerSectionAvatarAvatarRoundedsImageProps(item) : (bannerSectionAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        bannerSectionAvatarAvatarRoundedsItemWrapper,
                                        bannerSectionAvatarAvatarRoundedsRenderer
                                    )}
                                </div>
                                <div>
                                    <p className="avatar-ttile">
                                        {divDiv0Div0Div0Div0Div1Div1P0PText}
                                        <span className="d-block">{divDiv0Div0Div0Div0Div1Div1P0Span0SpanText}</span>
                                        {" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-6">
                            <div className="banner-right-nine position-relative">
                                {renderNode(divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-three" {...(divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                <div className="banner-img">
                                    {renderNode(divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid banner-img-one" {...(divDiv0Div0Div0Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <div className="counter-item-nine one">
                                    <p className="count">
                                        <span>{divDiv0Div0Div0Div1Div0Div1P0Span0SpanText}</span>
                                        {divDiv0Div0Div0Div1Div0Div1P0PText}
                                    </p>
                                    <p>{divDiv0Div0Div0Div1Div0Div1P1PText}</p>
                                </div>
                                <div className="counter-item-nine two">
                                    <p className="count">
                                        <span>{divDiv0Div0Div0Div1Div0Div2P0Span0SpanText}</span>
                                        {divDiv0Div0Div0Div1Div0Div2P0PText}
                                    </p>
                                    <p>{divDiv0Div0Div0Div1Div0Div2P1PText}</p>
                                </div>
                                <div className="counter-item-nine three">
                                    <p className="count">
                                        <span>{divDiv0Div0Div0Div1Div0Div3P0Span0SpanText}</span>
                                        {divDiv0Div0Div0Div1Div0Div3P0PText}
                                    </p>
                                    <p>{divDiv0Div0Div0Div1Div0Div3P1PText}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {renderNode(divDiv0ImageWithBasePath0ImageVisible, divDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={divDiv0ImageWithBasePath0ImageSrc} alt={divDiv0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(divDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
            </div>
            <div className="name one">{divDiv1DivText}</div>
            <div className="name two">{divDiv2DivText}</div>
            <div className="name three">{divDiv3DivText}</div>
            {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="img-fluid img-two" {...(divImageWithBasePath0ImageProps ?? {})} />
            ))}
        </div>
    );
};

export default HomeNineBannerSectionGenerated;
